import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CalendarDays, Compass, Map, Users, User } from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  { to: '/', icon: CalendarDays, label: 'Events' },
  { to: '/experiences', icon: Compass, label: 'Experiences' },
  { to: '/map', icon: Map, label: 'Map' },
  { to: '/activity', icon: Users, label: 'Community' },
  { to: '/dashboard', icon: User, label: 'Profile' },
];

export const MobileBottomNav: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="md:hidden fixed bottom-4 left-3 right-3 z-[2000] pointer-events-none">
      <div className="pointer-events-auto bg-background/70 backdrop-blur-xl border border-border/50 rounded-2xl shadow-lg px-2 py-1.5 flex items-center justify-around">
        {navItems.map(({ to, icon: Icon, label }) => (
          <Link
            key={to}
            to={to}
            className={cn(
              "flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-xl transition-colors min-w-0",
              isActive(to)
                ? "text-primary"
                : "text-muted-foreground"
            )}
          >
            <Icon className={cn("w-5 h-5", isActive(to) && "stroke-[2.5]")} />
            <span className="text-[10px] font-medium leading-tight">{label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};
